import React from 'react'
import { oneOfType, shape, string, node, arrayOf, func } from 'prop-types'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import { button } from '@groovehq/internal-design-system/lib/styles/elements'
import { OptionsHorizontal } from '@groovehq/internal-design-system/lib/assets/icons'
import DropdownMenu from './DropdownMenu'

import { styles } from './styles'

const UsersDropdown = ({
  dropdownList,
  footerName,
  onClickFooterBtn,
  className,
  onSelect,
}) => {
  const footerBtns = footerName ? (
    <button type="button" css={button.styles.link} onClick={onClickFooterBtn}>
      {footerName}
    </button>
  ) : null

  return (
    <Dropdown
      css={styles.base}
      overlay={<DropdownMenu data={dropdownList} />}
      footer={footerBtns}
      onSelect={onSelect}
      className={className}
      strategy="fixed"
    >
      <button type="button" css={button.styles.link}>
        <OptionsHorizontal css={styles.icon} />
      </button>
    </Dropdown>
  )
}

UsersDropdown.propTypes = {
  dropdownList: arrayOf(shape({ key: string, title: string })),
  footerName: oneOfType([node, string]),
  onClickFooterBtn: func,
  className: string,
  onSelect: func,
}

UsersDropdown.defaultProps = {
  dropdownList: [],
  footerName: undefined,
  onClickFooterBtn: undefined,
  className: undefined,
  onSelect() {},
}

export default UsersDropdown
